import React from "react";
import SpinnerCircular from "sushiweb/Spinner/SpinnerCircular";
import NoFooterModal from "../../../components/Common/NoFooterModal";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import VideoUploader from "../../../components/Common/VideoUploader";
import styled from "styled-components";

const FCAudioUpload = ({
  handleCloseModal,
  isUploading,
  handleAudioChange,
  handleUrlChange,
  mediaType,
  presign_url,
}) => {
  return (
    <NoFooterModal
      header={true}
      heading={`Upload Audio`}
      handleClose={handleCloseModal}
      id="fcTaskMediaUploadModal"
    >
      <FlexContainer justify="flex-start">
        <FlexContainer>
          {!isUploading ? (
            <React.Fragment>
              <VideoUploader
                handleVideoChange={handleAudioChange}
                id={`imageUpload`}
                state="Add"
                imageKey={"thumbnail"}
                uploadUrl={"/fleet_coach/tasks/upload_audio/ack"}
                callback_key={true}
                presign_url={presign_url}
                keyName="callback_key"
                maxSize={5}
                handleVideoUrlChange={() => handleUrlChange(mediaType)}
                acceptedFormats="audio/mp3"
                noAckCall
              />
              <InfoText className="flex mb-26 ml-26 text-grey pill">
                <ul>
                  <li>Maximum MP3 Size: 5 MB</li>
                  <li>Supported Format: "MP3"</li>
                </ul>
              </InfoText>
            </React.Fragment>
          ) : (
            <SpinnerCircular
              size="large"
              color={variables.grey500}
              className="justify-between"
            />
          )}
        </FlexContainer>
      </FlexContainer>
    </NoFooterModal>
  );
};

const InfoText = styled.div`
  width: 300px;
`;

export default FCAudioUpload;
